/** Shared readings of health messages, kept free of React so they can be tested. */

import {
    type CameraReplacementWarning, type HealthMessagePayload, HealthMessageType,
} from '@/types/healthMessages';

import { isPlainObject } from './webStorage';

/** The details of a replacement warning are the type's own, so only they are looked into. */
export function isCameraReplacementWarning(
    message: HealthMessagePayload,
): message is CameraReplacementWarning {
    return message.type === HealthMessageType.CameraReplacementWarning &&
        isPlainObject(message.details) &&
        typeof message.details.deviceId === 'string' && message.details.deviceId !== '';
}
